import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=1275d3fd&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=ts&"
export * from "./Footer.vue?vue&type=script&lang=ts&"
import style1 from "./Footer.vue?vue&type=style&index=1&id=1275d3fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1275d3fd",
  null
  
)

export default component.exports